export default {
  "@type": "defaultFuzz",
  "fuzzes": [
    {
      "name": "Organisation - Datasektionen.se",
      "str": "organisation",
      "color": "#e83d84",
      "href": "https://datasektionen.se/organisation"
    },{
      "name": "Näringsliv - Datasektionen.se",
      "str": "näringsliv industry contact",
      "color": "#e83d84",
      "href": "https://datasektionen.se/naringsliv"
    },{
      "name": "Studier - Datasektionen.se",
      "str": "studier",
      "color": "#e83d84",
      "href": "https://datasektionen.se/studier"
    },{
      "name": "Calypso - Nyhetssystemet",
      "str": "nyheter calypso prometheus event post news",
      "color": "#e91e63",
      "href": "https://calypso.datasektionen.se"
    },{
      "name": "Zfinger",
      "str": "xfinger zfinger",
      "color": "#00bcd4",
      "href": "https://zfinger.datasektionen.se"
    },{
      "name": "Skywhale - Valsystemet",
      "str": "val valsystem skywhale",
      "color": "#06b",
      "href": "https://val.datasektionen.se"
    },{
      "name": "Pandora - Bokningssystemet",
      "str": "bandora bokning bil kamera lokalbokning",
      "color": "#42a5f5",
      "href": "https://bokning.datasektionen.se"
    },{
      "name": "SL",
      "str": "SL tåg tunnelbana",
      "color": "red",
      "href": "http://sl.datasektionen.se/metro"
    },{
      "name": "Datasektionen.se",
      "str": "bawang datasektionen.se",
      "color": "#FDDE00",
      "href": "https://datasektionen.se"
    },{
      "name": "dfunkt",
      "str": "dfunkt",
      "color": "#ab47bc",
      "href": "https://dfunkt.datasektionen.se"
    },{
      "name": "dbuggen",
      "str": "dbuggen tidning",
      "color": "#0ab87a",
      "href": "https://dbu.gg"
    },{
      "name": "Motioner",
      "str": "motioner",
      "color": "white",
      "href": "https://motioner.datasektionen.se"
    },{
      "name": "Metaspexet",
      "str": "metaspexet",
      "color": "red",
      "href": "http://metaspexet.se"
    },{
      "name": "Damm",
      "str": "damm historia",
      "color": "#e83d84",
      "href": "https://damm.datasektionen.se"
    },
    {
      "name": "D-dagen",
      "str": "ddagen",
      "color": "red",
      "href": "https://ddagen.se"
    },{
      "name": "Duckumentation",
      "str": "dokumentation api swagger duckumentation",
      "color": "#4caf50",
      "href": "https://duckumentation.datasektionen.se"
    },
  ]
}
